import { Button } from "@/components/ui/button";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

const SKELETON_ROWS = ["alpha", "bravo"];

type MaterialRequestQueueEntry = {
	material?: string | number | null;
	materialId?: string | number | null;
	name?: string | null;
	quantity?: number | null;
	type?: string | null;
	toStock?: boolean | null;
};

type MaterialRequestQueueTableProps = {
	requests?: MaterialRequestQueueEntry[];
	loading?: boolean;
	onRemove: (request: MaterialRequestQueueEntry) => void;
};

const formatDestination = (entry: MaterialRequestQueueEntry) =>
	entry.toStock ? "Stock" : "Reparação";

const formatState = (entry: MaterialRequestQueueEntry) =>
	entry.type === "new" ? "Novo" : "Usado";

export function MaterialRequestQueueTable({
	requests = [],
	loading = false,
	onRemove,
}: MaterialRequestQueueTableProps) {
	const renderSkeleton = () => (
		<TableBody>
			{SKELETON_ROWS.map((rowKey) => (
				<TableRow key={`request-queue-${rowKey}`} className="animate-pulse">
					<TableCell>
						<div className="h-4 w-16 rounded bg-muted/70" />
					</TableCell>
					<TableCell>
						<div className="h-4 w-10 rounded bg-muted/60" />
					</TableCell>
					<TableCell>
						<div className="h-4 w-36 rounded bg-muted/50" />
					</TableCell>
					<TableCell>
						<div className="h-4 w-16 rounded bg-muted/50" />
					</TableCell>
					<TableCell className="text-right">
						<div className="ml-auto h-8 w-24 rounded bg-muted/40" />
					</TableCell>
				</TableRow>
			))}
		</TableBody>
	);

	return (
		<div className="tp-MaterialRequest__table overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead className="w-[100px]">Dest.</TableHead>
						<TableHead className="w-[85px]">Qnt.</TableHead>
						<TableHead>Material</TableHead>
						<TableHead className="w-[100px] text-center">Estado</TableHead>
						<TableHead className="w-[100px]" />
					</TableRow>
				</TableHeader>
				{loading ? (
					renderSkeleton()
				) : (
					<TableBody>
						{requests.map((request) => {
							const rowKey =
								request.materialId ??
								request.material ??
								request.name ??
								"request-row";

							return (
								<TableRow key={rowKey}>
									<TableCell>{formatDestination(request)}</TableCell>
									<TableCell>{request.quantity ?? 0}</TableCell>
									<TableCell>{request.name ?? "-"}</TableCell>
									<TableCell className="text-center">
										{formatState(request)}
									</TableCell>
									<TableCell className="text-right">
										<Button
											size="sm"
											variant="secondary"
											onClick={() => onRemove(request)}
										>
											Remover
										</Button>
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				)}
			</Table>
		</div>
	);
}
